import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import $ from 'jquery';


import { tyroResetModal, tyroResetStatus } from '../../actions';
import TyroModalContent from './TyroModalContent';


class TyroPairModal extends Component {
  componentDidUpdate(prevProps) {
    const { isModalActive: prevModalStatus } = prevProps;
    const { isModalActive: currModalStatus } = this.props;

    if (prevModalStatus !== currModalStatus) {
      this.handleModalActive(currModalStatus);
    }
  }

  handleModalActive(showModal) {
    const { id, tyroResetModal, tyroResetStatus } = this.props;
    if (showModal) {
      $(`#${id}`)
        .modal({
          closable: false,
          observeChanges: true,
          allowMultiple: true,
          onHidden: () => {
            tyroResetStatus();
            tyroResetModal();
          }
        })
        .modal("setting", "transition", "drop")
        .modal("show");

    } else {
      $(`#${id}`).modal("hide");
    }
  }

  render() {
    const { id } = this.props;

    return (
      <div className="ui small compact modal" id={id}>
        <div className="header">Tyro</div>
        <TyroModalContent />
      </div>
    );
  }
}


function mapStateToProps(state) {
  const { tyro: { modal } = {} } = state;
  const { isModalActive = false } = modal || {};
  return {
    isModalActive
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    tyroResetModal,
    tyroResetStatus
  }, dispatch);
}


TyroPairModal.propTypes = {
  id: PropTypes.string.isRequired
}


export default connect(mapStateToProps, mapDispatchToProps)(TyroPairModal);